import { render, staticRenderFns } from "./SharedMediaFolderUpdate.vue?vue&type=template&id=91f38e2e&"
import script from "./SharedMediaFolderUpdate.vue?vue&type=script&lang=js&"
export * from "./SharedMediaFolderUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports